import { QueryClient } from '@tanstack/react-query'
import { isRetryableError } from './api-error'

export const MAX_RETRIES = 2

/** Retry transient failures at most twice; never retry 4xx or contract violations. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  return failureCount < MAX_RETRIES && isRetryableError(error)
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 30_000,
        // TV and kiosk screens rarely get focus events; realtime pushes freshness instead.
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  })
}
